window.WatchlistApp = window.WatchlistApp || {};

window.WatchlistApp.Popup = (function () {
    let addUnitOptions = {};

    function showAddUnitPopup(options = {}) {
        addUnitOptions = options || {};
        const App = window.WatchlistApp;
        let popup = document.getElementById('add-unit-popup');
        if (!popup) {
            popup = document.createElement('div');
            popup.id = 'add-unit-popup';
            popup.className = 'pop-up-container';

            popup.innerHTML = `
                <div class="bg"></div>
                <div class="pop-up add-unit-popup-content">
                    <div class="header">
                        <h2>Add to Watchlist</h2>
                        <button class="close-button">
                            <img src="./desktop_assets/cross.svg" alt="Close">
                        </button>
                    </div>
                    <div class="content">
                         <div class="popup-search-container">
                              <input type="text" class="popup-search-input" placeholder="Search ticker...">
                              <div class="popup-suggestions"></div>
                         </div>
                         
                         <div class="selected-ticker-display"></div>
            
                         <div class="popup-inputs-row">
                             <div class="input-group">
                                 <p class="input-label"># of Shares</p>
                                 <input type="number" class="popup-qty-input" placeholder="0.00" min="0" step="any">
                                 <div class="error-msg qty-error">Negative values are not allowed</div>
                             </div>
                             <div class="input-group">
                                <p class="input-label">Cost Basis (Total cost for all shares)</p>
                                <input type="number" class="popup-price-input" placeholder="$0.00" min="0" step="any">
                                <div class="error-msg price-error">Negative values are not allowed</div>
                             </div>
                         </div>
            
                         <div class="popup-buttons">
                             <button class="cancel-popup-btn">Cancel</button>
                             <button class="confirm-popup-btn" disabled>Add</button>
                         </div>
                    </div>
                </div>
            `;
            document.body.appendChild(popup);

            const bg = popup.querySelector('.bg');
            const closeBtn = popup.querySelector('.close-button');
            const searchInput = popup.querySelector('.popup-search-input');
            const suggestionsEl = popup.querySelector('.popup-suggestions');
            const selectedDisplay = popup.querySelector('.selected-ticker-display');
            const confirmBtn = popup.querySelector('.confirm-popup-btn');
            const cancelBtn = popup.querySelector('.cancel-popup-btn');
            const qtyInput = popup.querySelector('.popup-qty-input');
            const priceInput = popup.querySelector('.popup-price-input');
            const qtyError = popup.querySelector('.qty-error');
            const priceError = popup.querySelector('.price-error');

            let selectedTicker = null;
            let selectedCompany = null;

            function closePopup() {
                popup.classList.remove('show');
                searchInput.value = '';
                qtyInput.value = '';
                priceInput.value = '';
                qtyError.style.display = 'none';
                priceError.style.display = 'none';
                selectedTicker = null;
                selectedCompany = null;
                selectedDisplay.style.display = 'none';
                confirmBtn.disabled = true;
                confirmBtn.style.opacity = '0.5';
                suggestionsEl.style.display = 'none';
            }

            bg.addEventListener('click', closePopup);
            closeBtn.addEventListener('click', closePopup);
            cancelBtn.addEventListener('click', closePopup);

            [qtyInput, priceInput].forEach(input => {
                input.addEventListener('input', () => {
                    qtyError.style.display = 'none';
                    priceError.style.display = 'none';
                });
                input.addEventListener('keydown', (e) => {
                    if (e.key === '-') {
                        e.preventDefault();
                    }
                });
            });

            searchInput.addEventListener('input', async (e) => {
                const query = e.target.value.trim();
                selectedTicker = null;
                selectedCompany = null;
                selectedDisplay.style.display = 'none';
                confirmBtn.disabled = true;
                confirmBtn.style.opacity = '0.5';

                if (query.length < 1) {
                    suggestionsEl.style.display = 'none';
                    return;
                }

                try {
                    const apiURL = 'https://api.palosverdestech.com/'
                    const response = await fetch(`${apiURL}/tickers/search/${encodeURIComponent(query)}`);
                    if (response.ok) {
                        const data = await response.json();
                        const results = (data.results || []).slice(0, 5);

                        suggestionsEl.innerHTML = '';
                        if (results.length > 0) {
                            results.forEach(company => {
                                const div = document.createElement('div');
                                div.className = 'suggestion-item';
                                div.innerHTML = `<span class="ticker">${company.ticker_symbol}</span><span class="company">${company.company_name}</span>`;

                                div.addEventListener('mouseenter', () => div.classList.add('hover'));
                                div.addEventListener('mouseleave', () => div.classList.remove('hover'));

                                div.onclick = () => {
                                    searchInput.value = company.ticker_symbol;
                                    selectedTicker = company.ticker_symbol;
                                    selectedCompany = company.company_name;
                                    suggestionsEl.style.display = 'none';
                                    selectedDisplay.textContent = `Selected: ${company.ticker_symbol} - ${company.company_name}`;
                                    selectedDisplay.style.display = 'block';
                                    confirmBtn.disabled = false;
                                    confirmBtn.style.opacity = '1';
                                };
                                suggestionsEl.appendChild(div);
                            });
                            suggestionsEl.style.display = 'block';
                        } else {
                            suggestionsEl.style.display = 'none';
                        }
                    }
                } catch (err) {
                    console.error('Search error', err);
                }
            });

            confirmBtn.addEventListener('click', async () => {
                const State = App.State;
                const Manager = App.Manager;

                if (addUnitOptions && addUnitOptions.onAdd) {
                     const qVal = parseFloat(qtyInput.value);
                     const pVal = parseFloat(priceInput.value);

                     if (!isNaN(qVal) && qVal < 0) {
                        qtyError.style.display = 'block';
                        return;
                     }
                     if (!isNaN(pVal) && pVal < 0) {
                        priceError.style.display = 'block';
                        return;
                     }
                     
                     const qty = qtyInput.value.trim() === '' ? null : (parseFloat(qtyInput.value) || 0);
                     let price = priceInput.value.trim() === '' ? null : (parseFloat(priceInput.value) || 0);
                     const ticker = selectedTicker;
                     const company = selectedCompany;

                     closePopup();
                     window.PreloaderManager?.show();
                     try {
                         await addUnitOptions.onAdd({
                             ticker: ticker,
                             companyName: company,
                             quantity: qty,
                             price: price
                         });
                     } catch(e) {
                         console.error(e);
                     } finally {
                         window.PreloaderManager?.hide();
                     }
                     return;
                }

                if (!selectedTicker || !State.currentWatchlistId) return;

                const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
                const currentStockCount = State.getCurrentWatchlistStockCount();

                if (!isPremium && currentStockCount >= 50) {
                     if (App.Popup && App.Popup.showPremiumLimitPopup) {
                         App.Popup.showPremiumLimitPopup(
                             "Unlimited stocks in watchlist are coming soon!",
                             "Adding more than 50 assets is a Pro feature currently in development."
                         );
                     }
                     return;
                }

                const qVal = parseFloat(qtyInput.value);
                const pVal = parseFloat(priceInput.value);

                if (!isNaN(qVal) && qVal < 0) {
                    qtyError.style.display = 'block';
                    return;
                }
                if (!isNaN(pVal) && pVal < 0) {
                    priceError.style.display = 'block';
                    return;
                }

                try {
                    confirmBtn.disabled = true;

                    const qty = qtyInput.value.trim() === '' ? null : (parseFloat(qtyInput.value) || 0);
                    let price = priceInput.value.trim() === '' ? null : (parseFloat(priceInput.value) || 0);
                    const ticker = selectedTicker;
                    const company = selectedCompany;

                    closePopup();
                    window.PreloaderManager?.show();

                    const result = await WatchlistAPIManager.instance.addTickersToWatchlist(
                        State.currentWatchlistId,
                        [{ ticker: ticker, quantity: qty, price: price }]
                    );

                    if (result && (result.success || result.watchlist)) {
                        State.addPendingAddition(ticker, {
                            price: price,
                            quantity: qty,
                            data: {
                                company_name: company,
                                price: price
                            }
                        }, State.currentWatchlistId);

                        await Manager.updateWatchlistState();
                        
                        const currentPrice = price || 0; 
                        
                        const newStockData = {
                            ticker: ticker,
                            company_name: company || ticker,
                            price: currentPrice,
                            todaysChange: 0,
                            todaysChangePerc: 0,
                            changePercentage: 0,
                            totalChangeDollar: 0,
                            totalChangePercent: 0,
                            quantity: qty,
                            market_cap: 0,
                            volume: 0,
                            sector_id: 0,
                            tickerDetails: {
                                name: company || ticker
                            }
                        };

                        if (State.currentWatchlistData) {
                            if (!Array.isArray(State.currentWatchlistData)) {
                                if (State.currentWatchlistData && typeof State.currentWatchlistData === 'object') {
                                    State.currentWatchlistData = Object.values(State.currentWatchlistData);
                                } else {
                                     State.currentWatchlistData = [];
                                }
                            }
                            
                            const existsIndex = State.currentWatchlistData.findIndex(s => s.ticker === ticker);
                            if (existsIndex === -1) {
                                State.currentWatchlistData.push(newStockData);
                            } else {
                                const existing = State.currentWatchlistData[existsIndex];
                                existing.quantity = qty;
                                if (price) existing.price = price;
                            }
                        } else {
                            State.currentWatchlistData = [newStockData];
                        }

                        try {
                            const visualizer = document.querySelector('[stock-cube-visualizer]');
                            if (visualizer && visualizer.components && visualizer.components['stock-cube-visualizer']) {
                                visualizer.components['stock-cube-visualizer'].updateWatchlistData([newStockData]);
                            }
                        } catch (e) {
                            console.warn('[Popup] Failed to update visualizer optimistically', e);
                        }

                        State.setCurrentWatchlistStockCount(State.currentWatchlistData.length);

                        document.body.dispatchEvent(new CustomEvent('watchlist-data-loaded', {
                            detail: {
                                stockInfo: State.currentWatchlistData,
                                totalStocks: State.totalStocks
                            },
                            bubbles: true
                        }));

                        if (State.currentUserId && State.currentWatchlistId) {
                            const isInWatchlistMode = document.body.classList.contains('watchlist-mode');
                            Manager.loadWatchlistData(State.currentUserId, State.currentWatchlistId, [], null, isInWatchlistMode, false);
                        }
                        const tableContainer = document.querySelector('.watchlist-table-container');
                        if (tableContainer) {
                            if (tableContainer.classList.contains('active') || tableContainer.style.display !== 'none') {
                                Table.renderWatchlistTable(tableContainer);
                            }
                        }
                        
                        const overlayTableContainer = document.querySelector('#edit-watchlist-overlay .overlay-table-container');
                        if (overlayTableContainer) {
                             const editOverlay = document.getElementById('edit-watchlist-overlay');
                             if (editOverlay && editOverlay.classList.contains('show')) {
                                 Table.renderWatchlistTable(overlayTableContainer, true);
                             }
                        }

                    } else {
                        console.error('Failed to add ticker. ' + (result?.message || ''));
                    }
                } catch (e) {
                    console.error('Error adding ticker', e);
                } finally {
                    window.PreloaderManager?.hide();
                }
            });

        }

        popup.classList.add('show');
    }

    function showInputPopup(title, initialValue, placeholder, confirmText, onConfirm, validationOptions = {}) {
        let popup = document.getElementById('input-popup');
        if (popup) {
            document.body.removeChild(popup);
        }

        popup = document.createElement('div');
        popup.id = 'input-popup';
        popup.className = 'pop-up-container';

        popup.innerHTML = `
            <div class="bg"></div>
            <div class="pop-up input-popup-content">
                <div class="header">
                    <h2>${title}</h2>
                    <button class="close-button">
                        <img src="./desktop_assets/cross.svg" alt="Close">
                    </button>
                </div>
                <div class="content">
                     <div class="input-group m-b-20">
                         <input type="text" class="popup-input" placeholder="${placeholder}" value="${initialValue || ''}">
                     </div>
        
                     <div class="popup-buttons">
                         <button class="cancel-popup-btn">Cancel</button>
                         <button class="confirm-popup-btn">${confirmText || 'Save'}</button>
                     </div>
                </div>
            </div>
        `;
        document.body.appendChild(popup);

        const bg = popup.querySelector('.bg');
        const closeBtn = popup.querySelector('.close-button');
        const cancelBtn = popup.querySelector('.cancel-popup-btn');
        const confirmBtn = popup.querySelector('.confirm-popup-btn');
        const input = popup.querySelector('.popup-input');

        if (validationOptions.maxLength) {
            input.setAttribute('maxLength', validationOptions.maxLength);
        }

        if (validationOptions.restrictUnicode) {
            input.addEventListener('input', function () {
                this.value = this.value.replace(/[^\x00-\x7F]/g, "");
            });
        }

        function closePopup() {
            popup.classList.remove('show');
            setTimeout(() => {
                if (popup.parentNode) popup.parentNode.removeChild(popup);
            }, 300);
        }

        bg.addEventListener('click', closePopup);
        closeBtn.addEventListener('click', closePopup);
        cancelBtn.addEventListener('click', closePopup);

        confirmBtn.addEventListener('click', async () => {
            const value = input.value.trim();
            if (!value) return;
            if (onConfirm) {
                closePopup();
                await onConfirm(value);
            } else {
                closePopup();
            }
        });

        input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && !confirmBtn.disabled) {
                confirmBtn.click();
            }
        });

        void popup.offsetWidth;
        popup.classList.add('show');
    }

    function showNotificationPopup(title, message, buttonText = 'OK') {
        let popup = document.getElementById('notification-popup');
        if (popup) {
            document.body.removeChild(popup);
        }

        popup = document.createElement('div');
        popup.id = 'notification-popup';
        popup.className = 'pop-up-container';

        popup.innerHTML = `
            <div class="bg"></div>
            <div class="pop-up notification-popup-content">
                <div class="header">
                    <h2>${title}</h2>
                    <button class="close-button">
                        <img src="./desktop_assets/cross.svg" alt="Close">
                    </button>
                </div>
                <div class="content">
                     <p class="message">${message}</p>
        
                     <div class="popup-buttons centered">
                         <button class="confirm-popup-btn">${buttonText}</button>
                     </div>
                </div>
            </div>
        `;
        document.body.appendChild(popup);

        const bg = popup.querySelector('.bg');
        const closeBtn = popup.querySelector('.close-button');
        const confirmBtn = popup.querySelector('.confirm-popup-btn');

        function closePopup() {
            popup.classList.remove('show');
            setTimeout(() => {
                if (popup.parentNode) popup.parentNode.removeChild(popup);
            }, 300);
        }

        bg.addEventListener('click', closePopup);
        closeBtn.addEventListener('click', closePopup);
        confirmBtn.addEventListener('click', closePopup);

        void popup.offsetWidth;
        popup.classList.add('show');
        confirmBtn.focus();
    }

    function showAddToWatchlistPopup(ticker, companyName) {
        let popup = document.getElementById('add-to-watchlist-popup');
        if (!popup) {
            popup = document.createElement('div');
            popup.id = 'add-to-watchlist-popup';
            popup.className = 'pop-up-container';
            popup.innerHTML = `
                <div class="bg"></div>
                <div class="pop-up add-to-watchlist-popup-content">
                    <div class="header">
                        <h2>Add to Watchlist</h2>
                        <button class="close-button">
                            <img src="./desktop_assets/cross.svg" alt="Close">
                        </button>
                    </div>
                    <div class="content">
                         <div class="popup-search-container m-b-20">
                              <p class="input-label m-b-8">Target Watchlist</p>
                              <div class="watchlist-selection-display">Loading...</div>
                         </div>
                         
                         <div class="selected-ticker-display show-bold">
                            Selected: ${ticker} - ${companyName || ''}
                         </div>
            
                         <div class="popup-inputs-row">
                             <div class="input-group">
                                 <p class="input-label"># of Shares</p>
                                 <input type="number" class="popup-qty-input" placeholder="0.00" min="0" step="any">
                                 <div class="error-msg qty-error">Negative values are not allowed</div>
                             </div>
                             <div class="input-group">
                                <p class="input-label">Cost Basis (Total cost for all shares)</p>
                                <input type="number" class="popup-price-input" placeholder="$0.00" min="0" step="any">
                                <div class="error-msg price-error">Negative values are not allowed</div>
                             </div>
                         </div>
            
                         <div class="popup-buttons">
                             <button class="cancel-popup-btn">Cancel</button>
                             <button class="confirm-popup-btn" disabled>Add</button>
                         </div>
                    </div>
                </div>
            `;
            document.body.appendChild(popup);
        }

        const bg = popup.querySelector('.bg');
        const closeBtn = popup.querySelector('.close-button');
        const cancelBtn = popup.querySelector('.cancel-popup-btn');
        const confirmBtn = popup.querySelector('.confirm-popup-btn');
        
        const qtyInput = popup.querySelector('.popup-qty-input');
        const priceInput = popup.querySelector('.popup-price-input');
        const qtyError = popup.querySelector('.qty-error');
        const priceError = popup.querySelector('.price-error');
        
        const watchlistDisplay = popup.querySelector('.watchlist-selection-display');
        
        qtyInput.value = '';
        priceInput.value = '';
        qtyError.style.display = 'none';
        priceError.style.display = 'none';
        confirmBtn.disabled = true;
        confirmBtn.style.opacity = '0.5';
        
        const displayEl = popup.querySelector('.selected-ticker-display');
        displayEl.textContent = `Selected: ${ticker} ${companyName ? '- ' + companyName : ''}`;

        let selectedWatchlistId = null;
        let watchlists = window.WatchlistApp.State.allWatchlists || [];

        const handleWatchlistData = (lists) => {
            if (!lists || lists.length === 0) {
                popup.classList.remove('show');
                
                const uname = window.WatchlistApp.Utils ? window.WatchlistApp.Utils.getCurrentUsername() : '';
                const defaultName = uname ? `${uname}'s Watchlist` : 'My Watchlist';

                window.WatchlistApp.Popup.showInputPopup(
                    'Create Watchlist',
                    defaultName,
                    'Enter watchlist name',
                    'Create',
                    async (name) => {
                        try {
                            await window.WatchlistApp.Manager.createWatchlist(name, true);
                            showAddToWatchlistPopup(ticker, companyName);
                        } catch (e) {
                            console.error('Failed to create watchlist', e);
                            alert('Failed to create watchlist');
                        }
                    },
                     { restrictUnicode: true }
                );
                return;
            }

            watchlists = lists;
            selectedWatchlistId = watchlists[0].id;
            watchlistDisplay.textContent = window.WatchlistApp.Utils.truncateName(watchlists[0].name, 20);
            confirmBtn.disabled = false;
            confirmBtn.style.opacity = '1';
            popup.classList.add('show');
        };

        if (!watchlists || watchlists.length === 0) {
            window.WatchlistAPIManager.instance.getWatchlists(true).then(data => {
                let lists = [];
                if (data && data.watchlists) {
                    lists = Array.isArray(data.watchlists) ? data.watchlists : (data.watchlists.watchlists || []);
                    window.WatchlistApp.State.allWatchlists = lists;
                }
                handleWatchlistData(lists);
            }).catch(() => {
                if (window.WatchlistApp?.Popup?.showNotificationPopup) {
                    window.WatchlistApp.Popup.showNotificationPopup('Error', 'Could not load watchlists. Please try again.');
                } else {
                    alert('Error loading watchlists');
                }
            });
        } else {
             handleWatchlistData(watchlists);
        }


        const closePopup = () => {
            popup.classList.remove('show');
        };

        bg.onclick = closePopup;
        closeBtn.onclick = closePopup;
        cancelBtn.onclick = closePopup;
        
        [qtyInput, priceInput].forEach(input => {
            input.oninput = () => {
                qtyError.style.display = 'none';
                priceError.style.display = 'none';
            };
            input.onkeydown = (e) => {
                if (e.key === '-') e.preventDefault();
            };
        });

        confirmBtn.onclick = async () => {
             if (!selectedWatchlistId) return;

             const Manager = window.WatchlistApp.Manager;
             const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
             const State = window.WatchlistApp.State;
             const targetWl = watchlists.find(w => w.id === selectedWatchlistId);
             let currentStockCount = 0;
             if (selectedWatchlistId === State.currentWatchlistId) {
                 currentStockCount = State.getCurrentWatchlistStockCount();
             } else if (targetWl && targetWl.tickers) {
                 currentStockCount = targetWl.tickers.length - (targetWl.missingTickersCount || 0);
             }

             if (!isPremium && currentStockCount >= 50) {
                  closePopup();
                  if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLimitPopup) {
                      window.WatchlistApp.Popup.showPremiumLimitPopup(
                          "Unlimited stocks in watchlist are coming soon!",
                          "Adding more than 50 assets is a Pro feature currently in development."
                      );
                  }
                  return;
             }
             
             const qVal = parseFloat(qtyInput.value);
             const pVal = parseFloat(priceInput.value);

             if (!isNaN(qVal) && qVal < 0) { qtyError.style.display = 'block'; return; }
             if (!isNaN(pVal) && pVal < 0) { priceError.style.display = 'block'; return; }

             const qty = qtyInput.value.trim() === '' ? null : (parseFloat(qtyInput.value) || 0);
             let price = priceInput.value.trim() === '' ? null : (parseFloat(priceInput.value) || 0);

             try {
                 confirmBtn.textContent = 'Adding...';
                 confirmBtn.disabled = true;
                 
                 const result = await window.WatchlistAPIManager.instance.addTickersToWatchlist(
                     selectedWatchlistId,
                     [{ ticker: ticker, quantity: qty, price: price }]
                 );
                 
                 if (result && (result.success || result.watchlist)) {
                     await window.WatchlistApp.Manager.updateWatchlistState();
                     
                     if (State.currentWatchlistId === selectedWatchlistId) {
                         if (document.body.classList.contains('watchlist-mode')) {
                             if (!State.currentWatchlistData) State.currentWatchlistData = [];
                              window.WatchlistApp.Manager.loadWatchlistData(window.WatchlistApp.State.currentUserId, selectedWatchlistId, [], null, true, false);
                         }
                     }
                     
                     window.WatchlistApp.Popup.showNotificationPopup('Success', `Added ${ticker} to watchlist.`);
                     closePopup();
                 } else {
                     alert('Failed to add ticker.');
                 }
             } catch (e) {
                 console.error(e);
                 alert('Error adding ticker');
             } finally {
                 confirmBtn.textContent = 'Add';
                 confirmBtn.disabled = false;
             }
        };


    }

    function showConfirmationPopup(title, message, leftBtnText, leftBtnAction, rightBtnText = 'Cancel', rightBtnAction = null, leftBtnClass = '', rightBtnClass = '') {
        let popup = document.getElementById('confirmation-popup');
        if (popup) {
            document.body.removeChild(popup);
        }

        popup = document.createElement('div');
        popup.id = 'confirmation-popup';
        popup.className = 'pop-up-container';

        popup.innerHTML = `
            <div class="bg"></div>
            <div class="pop-up notification-popup-content">
                <div class="header">
                    <h2>${title}</h2>
                    <button class="close-button">
                        <img src="./desktop_assets/cross.svg" alt="Close">
                    </button>
                </div>
                <div class="content">
                     <p class="message tertiary">${message}</p>

                     <div class="popup-buttons centered">
                         <button class="c-btn-left ${leftBtnClass}">${leftBtnText}</button>
                         <button class="c-btn-right ${rightBtnClass}">${rightBtnText}</button>
                     </div>
                </div>
            </div>
        `;
        document.body.appendChild(popup);

        const bg = popup.querySelector('.bg');
        const closeBtn = popup.querySelector('.close-button');
        const leftBtn = popup.querySelector('.c-btn-left');
        const rightBtn = popup.querySelector('.c-btn-right');

        function closePopup() {
            popup.classList.remove('show');
            setTimeout(() => {
                if (popup.parentNode) popup.parentNode.removeChild(popup);
            }, 300);
        }

        bg.onclick = closePopup;
        closeBtn.onclick = closePopup;

        leftBtn.onclick = async () => {
            if (leftBtnAction) {
                closePopup();
                await leftBtnAction();
            } else {
                closePopup();
            }
        };

        rightBtn.onclick = () => {
             if (rightBtnAction) rightBtnAction();
             closePopup();
        };

        void popup.offsetWidth;
        popup.classList.add('show');
    }

    function showPremiumLimitPopup(title, message) {
        let popup = document.getElementById('premium-limit-popup');
        if (popup) {
            document.body.removeChild(popup);
        }

        const defaultTitle = "Multiple Watchlists are coming soon!";
        const defaultMessage = "Organizing assets into different portfolios is a Pro feature currently in development.";

        popup = document.createElement('div');
        popup.id = 'premium-limit-popup';
        popup.className = 'pop-up-container';

        popup.innerHTML = `
            <div class="bg"></div>
            <div class="pop-up premium-limit-popup-content">
                <div class="content">
                    <h2>${title || defaultTitle}</h2>
                    <p class="premium-limit-message">
                        ${message || defaultMessage}
                     </p>
 
                      <div class="popup-buttons centered">
                          <button class="c-btn-left cancel-premium-limit-btn">Cancel</button>
                      </div>
                 </div>
             </div>
         `;
         document.body.appendChild(popup);
 
         const bg = popup.querySelector('.bg');
         const closeBtn = popup.querySelector('.close-button');
         const cancelBtn = popup.querySelector('.cancel-premium-limit-btn');
 
 
         function closePopup() {
             popup.classList.remove('show');
             setTimeout(() => {
                 if (popup.parentNode) popup.parentNode.removeChild(popup);
             }, 300);
         }
 
         if (bg) bg.onclick = closePopup;
         if (closeBtn) closeBtn.onclick = closePopup;
         cancelBtn.onclick = closePopup;
         
         void popup.offsetWidth;
         popup.classList.add('show');
     }

    function showRemoveConfirmationPopup(count, onConfirm) {
        let popup = document.getElementById('remove-confirmation-popup');
        if (popup) {
            document.body.removeChild(popup);
        }

        popup = document.createElement('div');
        popup.id = 'remove-confirmation-popup';
        popup.className = 'pop-up-container';

        popup.innerHTML = `
            <div class="bg"></div>
            <div class="pop-up notification-popup-content">
                <div class="header">
                    <h2>Remove Selected?</h2>
                    <button class="close-button">
                        <img src="./desktop_assets/cross.svg" alt="Close">
                    </button>
                </div>
                <div class="content">
                     <p class="message">Remove ${count} items?</p>
        
                     <div class="popup-buttons centered">
                         <button class="confirm-popup-btn button-accent">Remove</button>
                         <button class="cancel-popup-btn">Cancel</button>
                     </div>
                </div>
            </div>
        `;
        document.body.appendChild(popup);

        const bg = popup.querySelector('.bg');
        const closeBtn = popup.querySelector('.close-button');
        const cancelBtn = popup.querySelector('.cancel-popup-btn');
        const confirmBtn = popup.querySelector('.confirm-popup-btn');

        function closePopup() {
            popup.classList.remove('show');
            setTimeout(() => {
                if (popup.parentNode) popup.parentNode.removeChild(popup);
            }, 300);
        }

        bg.onclick = closePopup;
        closeBtn.onclick = closePopup;
        cancelBtn.onclick = closePopup;

        confirmBtn.onclick = async () => {
            closePopup();
            if (onConfirm) await onConfirm();
        };

        void popup.offsetWidth;
        popup.classList.add('show');
        confirmBtn.focus();
    }

    return {
        showAddUnitPopup,
        showInputPopup,
        showNotificationPopup,
        showAddToWatchlistPopup,
        showConfirmationPopup,
        showPremiumLimitPopup,
        showRemoveConfirmationPopup
    };
})();
